<template>
    <div>
      <guide-share-header :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :name="shareHaderName"></guide-share-header>
          <div class="guide-page-right">
        <div class="line-title">

            <div class="line-title-content">欧美国家办理</div>
            <div class="line-title-sub">
                <p>美国、英国、申根（法国、德国、意大利等都属于申根国家）等国家签证，在办理时都需要申请人亲自前往大使馆或签证中心。办理美国签证需要接受签证官的面试，而英国、申根等国家需要申请人将指纹录入系统。 正因为此类国家的签证都需要申请人亲自前往使馆，因此在办理过程中，签证专家需要向大使馆预约指定的赴馆时间。</p>
                <p>下面就详细介绍通过上上签平台办理此类国家签证的操作方式：</p>
            </div>

        </div>

         <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">01</div>
                    <div class="step-title-content">官网分为线上、线下订单办理，若选择线上办理，则前面几步操作与普通签证办理一致，都需要先选择对应的签证商品、
                      填写出行信息、上传电子资料、填写申请表。具体步骤可以查看  <router-link :to="{name:'uploadData'}" class="step-mark-a">上传资料</router-link>，
                      若选择线下办理，则在生成订单后直接进“选择赴馆日期”页面，线下订单步骤可查看 <router-link :to="{name:'offlineOrder'}" class="step-mark-a">线下订单</router-link>。</div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content"></div>

            </div>

            <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">02</div>
                    <div class="step-title-content">进入“选择赴馆日期”页面。推荐选择30天内“指定最佳赴馆日期前往”，这样签证专家就会帮申请人预约指定的日期。另外，也可视申请人实际情况，选择“近30天内任何时间都方便”或“近30天内均无法前往”。</div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content">
                    <img v-bind:src="imageBaseUrl + imageIndex[0]" alt="">
                </div>

            </div>

            <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">03</div>
                    <div class="step-title-content">若选择“指定最佳赴馆日期前往”，则需要继续选择具体的赴馆日期。点击日历中方便的日期，即可选中最佳赴馆日期。使馆开放预约的时间不稳定，因此请务必选择3个方便赴馆日期。签证专家会挑选其中一个大使馆系统允许预约的时间进行预约。</div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content">
                    <img v-bind:src="imageBaseUrl + imageIndex[1]" alt="">
                </div>

            </div>

            <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">04</div>
                    <div class="step-title-content">赴馆日期选择完毕后，完成“订单确认”并支付订单，此处操作与普通签证办理操作一致。具体步骤可以查看 <router-link :to="{name:'payOrder'}" class="step-mark-a">支付订单</router-link></div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content"></div>

            </div>

             <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">05</div>
                    <div class="step-title-content">支付完成并邮寄剩余资料后（部分签证不需邮寄资料），签证专家会审核申请人的所有资料。资料审核通过后，签证专家会根据下单时选择的赴馆时间进行预约操作，预约成功后，订单联系人手机和小程序都将收到通知消息。此时进入该“订单详情页”，点击申请人姓名可查看“赴馆通知书”，通知书内包含赴馆时间、使馆地址、携带资料、注意事项等。</div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content">
                    <img v-bind:src="imageBaseUrl + imageIndex[2]" alt="">
                    <img v-bind:src="imageBaseUrl + imageIndex[3]" alt="">
                </div>

            </div>


             <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">06</div>
                    <div class="step-title-content">若需要修改赴馆时间，则可点击“修改赴馆日期”，选择需要修改的申请人，并重新选择赴馆日期并提交。</div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content">
                    <img v-bind:src="imageBaseUrl + imageIndex[4]" alt="">
                </div>

            </div>
    </div>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuideShareHeader from '../component/GuideShareHeader';

export default {
  name: 'InterviewProduct',
  components: {
    GuideShareHeader,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=7',
      shareHaderName: '欧洲国家办理',
      imageBaseUrl: 'https://o.666visa.cn/static/common/guides/',
      imageIndex: [
        'pc_8_01.png',
        'pc_8_02.png',
        'pc_8_03.png',
        'pc_8_04.png',
        'pc_8_05.png',
      ],
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '欧洲国家办理',
    });
  },
};
</script>

<style lang="less">
@import "../../../assets/less/guide.less";
.step-content {
  img {
    max-width: 100%;
  }
}
.guide-page-right {
  padding: 30px 70px 30px 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/sub/interviewProduct.vue